// Utilities for OpenAI visualization

const normalizePermission = (p) => {
  if (!p) return 'Unknown';
  const s = String(p).toLowerCase();
  if (s.includes('read') && s.includes('write')) return 'Read & Write';
  if (s.includes('write')) return 'Write';
  if (s.includes('read')) return 'Read';
  return p;
};

const getPermissionColor = (permission) => {
  const p = normalizePermission(permission);
  if (p === 'Read') return '#22c55e'; // green
  if (p === 'Write') return '#f59e0b'; // amber
  if (p === 'Read & Write') return '#3b82f6'; // blue
  return '#94a3b8'; // slate
};

// Groups OpenAI scopes into high-level categories
const groupOpenAIScopesIntoCategories = (scopes) => {
  const categories = {
    'Models': [],
    'Audio & Related': [],
    'Assistants & Threads': [],
    'Fine-Tuning & Files': [],
    'Evals & Responses': [],
  };

  const add = (cat, entry) => { categories[cat].push(entry); };

  (scopes || []).forEach((s) => {
    const scopePath = s.scope || '';
    const entry = {
      scope: scopePath,
      endpoints: Array.isArray(s.endpoints) ? s.endpoints : [],
      permission: normalizePermission(s.permission),
    };

    if (scopePath.startsWith('/v1/models')) {
      add('Models', entry);
    } else if (
      scopePath.startsWith('/v1/audio') ||
      scopePath.startsWith('/v1/embeddings') ||
      scopePath.startsWith('/v1/images') ||
      scopePath.startsWith('/v1/chat') ||
      scopePath.startsWith('/v1/moderations')
    ) {
      add('Audio & Related', entry);
    } else if (scopePath.startsWith('/v1/assistants') || scopePath.startsWith('/v1/threads')) {
      add('Assistants & Threads', entry);
    } else if (scopePath.startsWith('/v1/fine_tuning') || scopePath.startsWith('/v1/files')) {
      add('Fine-Tuning & Files', entry);
    } else if (scopePath.startsWith('/v1/evals') || scopePath.startsWith('/v1/responses')) {
      add('Evals & Responses', entry);
    } else {
      // Unknown → bucket into related group by endpoints heuristic
      add('Models', entry);
    }
  });

  return categories;
};

export { groupOpenAIScopesIntoCategories, getPermissionColor };



